import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getMachineryDetail, editMachinery, getMachineries } from '../../../actions/machineriesActions'
import FormMachinery from '../../admin/machineries/FormMachinery'
import Swal from 'sweetalert2'

export default function MachineryEdit() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {machinery} = useSelector(state=>state.machineries)   
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {plate, name, description, type, chassis, roma, year, check, idMachinery} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()

        dispatch(editMachinery(plate, name, description, type, chassis, roma, year, check, idMachinery))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('machineries.messageedit')
        })
    }


    useEffect(()=>{
        dispatch(getMachineryDetail(id))
        dispatch(getMachineries())
    }, [dispatch,id])

    useEffect(() => {
        if (machinery) {
            setFormState({
                plate: machinery.plate,
                name: machinery.name,
                description: machinery.description,
                type: machinery.type,
                chassis: machinery.chassis,
                roma: machinery.roma,
                year: machinery.year,
                check: machinery.check,
                idMachinery: machinery._id
            })
        }
    }, [machinery, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/machineries`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('machineries.volver')}
                    </Button>
                </Row>
                <h1>{t('machineries.name')}: <span className='text-uppercase'>{machinery?.name}</span></h1>
                <FormMachinery submit={handleEdit} isNew={false} inputChange={handleInputChange} state={formState}></FormMachinery>
            </Row>
        </Container>
    )
}
